import { PropsWithChildren } from "react";
import { PrimaryButton, DefaultButton } from "@fluentui/react/lib/Button";
import { Dialog, DialogFooter, DialogType } from "@fluentui/react/lib/Dialog";

import { IConfirmDialogProps } from "./IConfirmDialogProps";

export function ConfirmDialog(props: PropsWithChildren<IConfirmDialogProps>): JSX.Element {
  const {
    children, confirmButtonText, dismissButtonText, hidden = true, onConfirm, onDismiss, subText, title
  } = props;

  return (
    <Dialog
      hidden={hidden}
      onDismiss={onDismiss}
      dialogContentProps={{
        type: DialogType.largeHeader,
        title,
        subText
      }}
      modalProps={{
        isDarkOverlay: true,
        isBlocking: false
      }}
      styles={{
        main: {
          width: `480px !important`,
          maxWidth: `480px !important`
        }
      }}
    >
      {children}
      <DialogFooter>
        {onDismiss != null && <PrimaryButton onClick={onDismiss} text={dismissButtonText} />}
        {onConfirm != null && <DefaultButton onClick={onConfirm} text={confirmButtonText} />}
      </DialogFooter>
    </Dialog>
  );
}
